export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylish%20young%20adult%20sitting%20on%20a%20modern%20couch%20browsing%20fashion%20items%20on%20a%20laptop%20with%20shopping%20bags%20on%20the%20floor%20bright%20sunlit%20living%20room%20with%20large%20windows%20and%20indoor%20plants%20lifestyle%20ecommerce%20photography%20warm%20inviting%20modern%20home&width=1600&height=700&seq=cta-bg-v2-main&orientation=landscape"
        alt="Get the full pandabuy spreadsheet now"
        title="PandaBuy Spreadsheet - Start Exploring"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/30" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-lg">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight text-balance">
            get the full pandabuy sheet now
          </h2>

          <div className="mt-10">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-white text-foreground-900 text-sm md:text-base font-semibold hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              open database
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-900">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </span>
            </a>
          </div>
        </div>

        <div className="mt-8 max-w-sm">
          <p className="text-white/75 text-sm leading-relaxed">
            Instant access to the most viral, updated, and curated
            pandabuyspreadsheet database available online.
          </p>
        </div>
      </div>
    </section>
  );
}